// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import { store } from './store';
import config from './config';
import 'json2csv';
import 'babel-polyfill';

// Importing only the icons we are using to reduce bundle size
import 'vue-awesome/icons/times';
import 'vue-awesome/icons/exclamation-triangle';
import 'vue-awesome/icons/plus';
import 'vue-awesome/icons/print';
import 'vue-awesome/icons/file-pdf';
import 'vue-awesome/icons/file-image';
import 'vue-awesome/icons/angle-left';
import 'vue-awesome/icons/angle-double-left';
import 'vue-awesome/icons/angle-right';
import 'vue-awesome/icons/angle-double-right';
import 'vue-awesome/icons/bars';
import 'vue-awesome/icons/user';
import 'vue-awesome/icons/spinner';
import 'vue-awesome/icons/angle-up';
import Icon from 'vue-awesome/components/Icon'
// Accessibility - Skip to main content
import VueSkipTo from 'vue-skip-to';
// Accessibility - Announcing route changes, toasts for screen readers
import VueAnnouncer from 'vue-announcer';

// Notification/Toasts
import Toasted from 'vue-toasted/dist/vue-toasted.js';

// highcharts
import HighchartsVue from 'highcharts-vue';
import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
Exporting(Highcharts);
import LoadDrilldown from 'highcharts/modules/drilldown';
LoadDrilldown(Highcharts);

// Tabs
import Tabs from 'vue-tabs-component';

// vue-i18n
import i18n from './translations/i18n';

// match-heights
import VueMatchHeights from 'vue-match-heights';

// Register v-icon component globally
Vue.component('v-icon', Icon);

Vue.use(Toasted);

Highcharts.setOptions({
  lang: {
    decimalPoint: '.',
    thousandsSep: ','
  },
  global: {
    useUTC: false
  }
});
Vue.use(HighchartsVue, { Highcharts });

Vue.use(VueMatchHeights, { disabled: [768] });

Vue.use(Tabs);

Vue.use(config, store, router);

// Register global success and error notification toasts
Vue.toasted.register('success', (payload) => { return payload ? payload : "Success" }, { type: 'success', theme: 'primary', position: 'top-center', duration: '2000' });

Vue.toasted.register('error', (payload) => { return payload ? payload : "Error has occurred" }, { type: 'error', theme: 'primary', position: 'top-center', duration: '2000' });

Vue.component('v-style', {
  render: function (createElement) {
    return createElement('style', this.$slots.default)
  }
});

Vue.use(VueSkipTo);

Vue.use(VueAnnouncer, {}, router);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  template: '<App/>'
});